export default __webpack_public_path__ + "static/media/Deacon's Gauntlets of the Eighteen Pits.a502e40d.jpg";